import { useEffect, useState } from 'react'
import useAnalytics from 'hooks/useAnalytics'

export default function useDefaultStep({ fireboltStep,
  beforeSubmitStep,
  customGoBack }) {
  const { track, trackersLoaded } = useAnalytics() || {}
  const [runnedStepStart, setRunnedStepStart] = useState(false)

  useEffect(_runStepStartedTracking, [fireboltStep, trackersLoaded])

  useEffect(_runStepStartedTracking, [fireboltStep, trackersLoaded])

  function _runStepStartedTracking() {
    if (fireboltStep?.position !== 0 && trackersLoaded && !runnedStepStart) {
      setRunnedStepStart(true)
    }
  }

  // runs on user click 'continue' button
  function runBeforeChangeStep(formData) {
    if (!!beforeSubmitStep) beforeSubmitStep(formData)
  }

  function handleGoBackform() {
    const isFirstStep = fireboltStep?.position === 1

    if (isFirstStep) {
      const fullPathname = window.location.pathname
      const newPathName = fullPathname.split('/proposta')[0]
      window.location.pathname = newPathName
    } else {
      fireboltStep?.goPreviousStep()
    }
  }

  function customTrackedGoBack() {
    customGoBack()
  }

  return {
    handleGoBackform: customGoBack ? customTrackedGoBack : handleGoBackform,
    runBeforeChangeStep,
  }
}
